import type { CollectableFeeRow } from '@klear/collection'
import type { CollectableRecovery } from '@/app/collections/outlet-context'

export const COLLECTION_REFERENCE_HIGHLIGHT_ROW_CLASS = 'collection-reference-highlight'

export function feeRowMatchesReferenceId(row: CollectableFeeRow, referenceId: number): boolean {
  const feeId = row.fee.id
  if (feeId === referenceId) return true
  if (row.fee.parentId === referenceId) return true
  if (row.invoiceOffer?.id === referenceId) return true
  return false
}

export function recoveryRowMatchesReferenceId(row: CollectableRecovery, referenceId: number): boolean {
  return row.id === referenceId
}
